import { SIGNATURE_LEAD } from '../../lib/shared/chatwootSignature'

export {
  appendSignatureForSend,
  hasSignature,
  SIGNATURE_LEAD,
} from '../../lib/shared/chatwootSignature'

export function composeReplyWithDraft(content: string, draft: string): string {
  const existing = content.replace(/\s+$/, '')
  return existing ? `${existing}${SIGNATURE_LEAD}${draft}` : draft
}
